import React, { Component } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableFooter,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Resource from "common/components/Resource";
import Pagination from "common/components/Pagination";
import { ClickableTableCell } from "common/components/Table";
import EnhancedCard from "common/components/EnhancedCard";
import { withUrlResource } from "common/utils";
import { Translation } from "react-i18next";

class ContactTopicList extends Component {
  state = {
    categoryFilter: "",
  };

  render() {
    const { classes, match, history, urlResource } = this.props;

    return (
      <Translation>
        {(t) => (
          <EnhancedCard
            title={t("contact_topics_list.title")}
            cardContentRoot={{ padding: 0 }}
            cardHeaderStyle={{ fontSize: "1.25rem" }}
            action={
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  history.push(
                    `/${urlResource.singular}/${urlResource.id}/contact_topics/new`,
                  );
                }}
              >
                {t("contact_topics_list.add_btn")}
              </Button>
            }
          >
            <Resource
              name={`${urlResource.plural}/${urlResource.id}/contact_topics`}
              error={() => (
                <Typography>{t("contact_topics_list.error")}</Typography>
              )}
              render={(topics, { prevPage, nextPage, page, removeOne }) => (
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell classes={{ root: classes.th }}>
                        {t("contact_topics_list.th_id")}
                      </TableCell>
                      <TableCell classes={{ root: classes.th }}>
                        {t("contact_topics_list.th_name")}
                      </TableCell>
                      <TableCell classes={{ root: classes.th }}>
                        {t("contact_topics_list.th_contact_email")}
                      </TableCell>
                      <TableCell classes={{ root: classes.th }}>
                        {t("contact_topics_list.th_delete")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {topics.length ? (
                      topics.map((topic) => (
                        <TableRow hover key={topic.id}>
                          <TableCell className={classes.td}>
                            {topic.id}
                          </TableCell>
                          <ClickableTableCell
                            style={{
                              color: "#000",
                              textDecoration: "underline",
                            }}
                            onClick={() =>
                              history.push(`${match.url}/edit/${topic.id}`)
                            }
                          >
                            {topic.name}
                          </ClickableTableCell>
                          <TableCell className={classes.td}>
                            {topic.contact_email}
                          </TableCell>
                          <TableCell className={classes.td}>
                            <IconButton style={{ padding: 0 }}>
                              <DeleteIcon onClick={() => removeOne(topic.id)} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell className={classes.td} colSpan={5}>
                          {t("contact_topics_list.no_records")}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TableCell colSpan={5} className={classes.pagination}>
                        <Pagination
                          page={page}
                          nextPage={nextPage}
                          prevPage={prevPage}
                          items={topics}
                        />
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>
              )}
            />
          </EnhancedCard>
        )}
      </Translation>
    );
  }
}

const styles = (theme) => ({
  th: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    backgroundColor: "#7f7f7f",
    color: "#fff",
    fontWeight: "bold",
  },
  td: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  table: {
    minWidth: 700,
    padding: 0,
  },
  pagination: {
    textAlign: "right",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});

ContactTopicList.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  history: PropTypes.object.isRequired,
  urlResource: PropTypes.shape({
    singular: PropTypes.string.isRequired,
    plural: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
};

const enhanced = compose(withStyles(styles), withUrlResource);

export default enhanced(ContactTopicList);
